import React from "react"
import { forwardRef } from "@design-system/core"
import { ModalSheet } from "./ModalSheet"
import { ModalSheetProps } from "./types"

export type ModalProps = Omit<ModalSheetProps, "align" | "isTouch">

export const Modal = forwardRef<ModalProps, "div">((props, ref) => (
  <ModalSheet {...props} align="center" isTouch={false} ref={ref} />
))
